// Language-learning niche type-pair specs for the wizard preview — a THIN
// CONSUMER of the generated typography catalog (B11 — typography de-mirror).
//
// The font pairs, weights, and spacing are authored ONCE in the shared TS source
// remotion-service/templates/src/shared/typography/language_learning_pairs.ts and
// emitted to the checked-in JSON below by generate-typography-catalog.mjs; this
// module just reshapes that catalog into the JS `bare` spec shape (font family
// alone, no uppercase, letter-spacing only when set). It no longer restates any
// font data, so it cannot drift from what the renderer paints — the Ruby leg
// (ShortsWizard::Shared::LanguageLearningTypePairs::SPECS) consumes the same JSON.
import catalog from "../../../remotion-service/templates/generated/typography/language_learning.json"
import { toJsSpecs, BARE_REQUIRED_SPEC_KEYS } from "./typography_catalog"

export const TYPE_PAIR_SPECS = toJsSpecs(catalog, { profile: "bare" })

export { BARE_REQUIRED_SPEC_KEYS as REQUIRED_SPEC_KEYS }
